import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

interface FamilyTariffIds {
    name: string;
    month: string;
    year: string;
}

type FamilyFeature = 'a' | 'b' | 'c' | 'd';

const familyTariffOnLandingWeb: FamilyFeature = getFeature('family-tariff-on-landing') || 'a';
const familyTariffOnLandingIos: FamilyFeature = getFeature('family-tariff-ios') || 'a';
const familyTariffOnLandingAndroid: FamilyFeature = getFeature('family-tariff-android') || 'a';
const familyTariffOnLandingTouch: FamilyFeature = IS_IOS_MOBILE ? familyTariffOnLandingIos : familyTariffOnLandingAndroid;

const familyTariffOnLanding: FamilyFeature =
    (IS_WEBVIEW || IS_MOBILE_BROWSER ? familyTariffOnLandingTouch : familyTariffOnLandingWeb) || 'a';

export const familyTariffOnLandingA: boolean = familyTariffOnLanding === 'a';
export const familyTariffOnLandingB: boolean = familyTariffOnLanding === 'b';
export const familyTariffOnLandingC: boolean = familyTariffOnLanding === 'c';
export const familyTariffOnLandingD: boolean = familyTariffOnLanding === 'd';

export const enabledFamilyTariff: boolean =
    !IS_BIZ_USER &&
    (((IS_WEBVIEW || IS_MOBILE_BROWSER) && familyTariffOnLandingTouch !== 'a') || (!IS_MOBILE_BROWSER && familyTariffOnLandingWeb !== 'a'));

const familyTariffIdsWeb: FamilyTariffIds = getFeature('family-tariff-ids');
const familyTariffIdsTouch: FamilyTariffIds = getFeature('family-tariff-ids-touch');
export const familyTariffIds: FamilyTariffIds = IS_WEBVIEW || IS_MOBILE_BROWSER ? familyTariffIdsTouch : familyTariffIdsWeb;

export const familyTariffIdFromQuery: string = getFeature('family-tariff-id-from-query') || 'W1TB_family_features_a';
